import React from 'react';
import PageHeader from '../components/HeroSection';

const LegalPrivacyPage = () => {
  // Font styles for headers
  const fontStyles = {
    header: {
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: 700,
      fontStyle: 'normal',
      fontSize: '64px',
      lineHeight: '100%',
      letterSpacing: '0.04em',
      textAlign: 'right',
      textTransform: 'uppercase'
    },
    headerSmall: {
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: 700,
      fontStyle: 'normal',
      fontSize: '48px',
      lineHeight: '100%',
      letterSpacing: '0.04em',
      textAlign: 'right',
      textTransform: 'uppercase'
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Page Header with Hero */}
      <PageHeader pageTitle="LEGAL & PRIVACY" />

      {/* Legal & Privacy Content Section */}
      <section className="pt-24 pb-20">
        <div className="mx-auto px-8 relative" style={{ width: '1600px' }}>
          {/* Vertical Stack Layout */}
          <div className="flex gap-24">
            {/* Left Side - Headers (stacked vertically) */}
            <div className="flex-shrink-0" style={{ width: '560px' }}>
              {/* Disclaimer Header */}
              <div style={{ marginBottom: '200px' }}>
                <h3 className="text-2xl text-gray-900" style={fontStyles.header}>DISCLAIMER</h3>
              </div>
              
              {/* Terms of Service Header */}
              <div style={{ marginBottom: '1810px' }}>
                <h3 className="text-2xl text-gray-900" style={fontStyles.headerSmall}>TERMS OF SERVICE</h3>
              </div>
              
              {/* Privacy Policy Header */}
              <div className="mb-32">
                <h3 className="text-2xl text-gray-900" style={fontStyles.headerSmall}>PRIVACY POLICY</h3>
              </div>
            </div>

            {/* Right Side - Content (stacked vertically) */}
            <div className="flex-shrink-0" style={{ width: '944px' }}>
              {/* Disclaimer Content */}
              <div style={{ marginTop: '20px', marginBottom: '155px' }} className="text-left">
                <p className="text-gray-700">This document is provided for informational purposes only and does not constitute formal legal advice. Hair to Dye For should consult with a licensed attorney to ensure these Terms of Service and Privacy Policy comply fully with federal, state, and local laws and meet the specific needs of the business.</p>
                
                {/* Divider */}
                <hr className="border-gray-300 my-8" />
              </div>

              {/* Terms of Service Content */}
              <div className="mb-32 space-y-6 text-left">
                <div>
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">1. USER AGREEMENT</h4>
                  <p className="text-gray-700">By accessing or using the "Hair to Dye For" website ("Website"), you agree to these "Terms of Service" ("Terms"). These Terms form a legally binding agreement between you and Hair to Dye For, a beauty salon located in Easton, Pennsylvania, United States. If you do not agree, you must not access or use the Website or its services.</p>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">2. ELIGIBILITY</h4>
                  <p className="text-gray-700">You must be at least 18 years old or the age of majority in your state to use the Website or book services. If under 18, services may only be used with parental or guardian consent. Services are intended for individuals located in the United States.</p>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">3. USE RESTRICTIONS</h4>
                  <p className="text-gray-700 mb-2">You agree not to:</p>
                  <ul className="list-disc list-inside text-gray-700 space-y-1 ml-4">
                    <li>Attempt to hack, disrupt, or gain unauthorized access to the Website or systems</li>
                    <li>Scrape or copy content, images, or data for commercial use without written permission</li>
                    <li>Use the Website for any unlawful purpose or in violation of these Terms</li>
                  </ul>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">4. INTELLECTUAL PROPERTY</h4>
                  <p className="text-gray-700">All content on the Website (text, images, videos, designs, logos) is the exclusive property of Hair to Dye For. Content is protected under U.S. copyright and trademark laws. You may not use, reproduce, or distribute content without written consent.</p>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">5. PAYMENTS, REFUNDS, AND CANCELLATIONS</h4>
                  <p className="text-gray-700">Payments for salon services are due at the time of service unless otherwise agreed. Deposits may be required for certain services (e.g., hair extensions, long-duration appointments). Deposits are non-refundable but can be applied to a rescheduled appointment if changes are made within the stated cancellation window. Prices are subject to change without notice.</p>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">6. USER RESPONSIBILITIES</h4>
                  <p className="text-gray-700 mb-2">You agree to:</p>
                  <ul className="list-disc list-inside text-gray-700 space-y-1 ml-4">
                    <li>Provide accurate and truthful information when contacting or booking services</li>
                    <li>Follow all instructions and aftercare guidance provided by your stylist</li>
                    <li>Notify the salon of any allergies, sensitivities, or medical conditions that may affect your service</li>
                  </ul>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">7. DISCLAIMERS AND NO GUARANTEES</h4>
                  <p className="text-gray-700">Hair to Dye For provides beauty services on an "as available" basis and makes no guarantees regarding specific results. Individual results may vary based on hair type, previous treatments, and adherence to aftercare instructions. The salon is not liable for outcomes that differ from client expectations where professional standards were met.</p>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">8. LIMITATION OF LIABILITY</h4>
                  <p className="text-gray-700">To the fullest extent permitted by law, Hair to Dye For, its owners, employees, and affiliates shall not be held liable for any indirect, incidental, consequential, or punitive damages arising from the use of our Website or services. Our total liability for any claim shall not exceed the amount paid by you for the service in question.</p>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">9. INDEMNITY</h4>
                  <p className="text-gray-700">You agree to indemnify and hold harmless Hair to Dye For, its owners, employees, and affiliates from any claims, damages, losses, liabilities, and expenses arising from your misuse of the Website or services, or your breach of these Terms.</p>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">10. TERMINATION OF ACCESS</h4>
                  <p className="text-gray-700">We reserve the right to terminate or suspend access to the Website or refuse service to anyone at our sole discretion, without prior notice, for conduct that violates these Terms or is harmful to others.</p>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">11. THIRD-PARTY LINKS</h4>
                  <p className="text-gray-700">This Website may contain links to third-party websites or services. We are not responsible for the content, policies, or practices of third-party sites and provide these links for convenience only.</p>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">12. GOVERNING LAW</h4>
                  <p className="text-gray-700">These Terms shall be governed by and construed under the laws of the Commonwealth of Pennsylvania and the United States, without regard to conflict of law principles.</p>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">13. RIGHT TO MODIFY TERMS</h4>
                  <p className="text-gray-700">Hair to Dye For reserves the right to modify these Terms at any time without prior notice. Updates will be posted on this Website, and continued use constitutes acceptance of the updated Terms.</p>
                </div>
                
                {/* Divider */}
                <hr className="border-gray-300 my-8" />
              </div>

              {/* Privacy Policy Content */}
              <div className="space-y-6 text-left">
                <p className="text-gray-700">Hair to Dye For respects your privacy and is committed to protecting your personal information. This Privacy Policy explains what data we collect, how we use it, and your rights regarding your information.</p>
                
                <div>
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">1. INFORMATION WE COLLECT</h4>
                  <p className="text-gray-700 mb-2">We may collect:</p>
                  <ul className="list-disc list-inside text-gray-700 space-y-1 ml-4">
                    <li>Personally Identifiable Information (PII): Name, phone number, email address, appointment details, and service preferences</li>
                    <li>Images and videos: With your consent, before-and-after photos or videos of services performed</li>
                    <li>Technical data: IP address, browser type, and basic website analytics</li>
                    <li>Cookies: Used for site functionality, analytics, and performance tracking</li>
                  </ul>
                  <p className="text-gray-700 mt-2">We do not collect financial or medical data through our Website.</p>
                </div>
                
                <div>
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">2. HOW WE COLLECT DATA</h4>
                  <p className="text-gray-700 mb-2">We collect data when you:</p>
                  <ul className="list-disc list-inside text-gray-700 space-y-1 ml-4">
                    <li>Fill out forms on our Website</li>
                    <li>Call or email us</li>
                  </ul>
                </div>
                
                <div>
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">3. WHY WE COLLECT DATA</h4>
                  <p className="text-gray-700 mb-2">We collect information to:</p>
                  <ul className="list-disc list-inside text-gray-700 space-y-1 ml-4">
                    <li>Provide and improve salon services</li>
                    <li>Communicate appointment details and updates</li>
                    <li>Share marketing materials, promotions, or updates (with your consent)</li>
                    <li>Post testimonials or transformation photos (with your permission)</li>
                    <li>Comply with legal obligations</li>
                  </ul>
                </div>
                
                <div>
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">4. DATA SHARING</h4>
                  <p className="text-gray-700 mb-2">We do not sell your information. We may share your information:</p>
                  <ul className="list-disc list-inside text-gray-700 space-y-1 ml-4">
                    <li>With service providers assisting in marketing, communications, or analytics</li>
                    <li>To comply with legal requirements or law enforcement</li>
                    <li>With your consent, for example, sharing photos on social media or our Website</li>
                  </ul>
                </div>
                
                <div>
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">5. COOKIES AND TRACKING</h4>
                  <p className="text-gray-700">Our Website may use cookies to improve user experience and collect analytics. You can manage cookie preferences in your browser settings.</p>
                </div>
                
                <div>
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">6. DATA SECURITY</h4>
                  <p className="text-gray-700">We implement reasonable administrative, technical, and physical safeguards to protect your data. However, no system can guarantee 100% security.</p>
                </div>
                
                <div>
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">7. YOUR RIGHTS</h4>
                  <p className="text-gray-700">If you are a California resident, you have rights under the CCPA to request access to, deletion of, or non-sale of your personal data. If you are in the EU, you may have rights under GDPR. Contact us to exercise these rights.</p>
                </div>
                
                <div>
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">8. DATA RETENTION</h4>
                  <p className="text-gray-700">We retain personal information only as long as necessary to fulfill the purposes outlined or as required by law.</p>
                </div>
                
                <div>
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">9. CHILDREN'S PRIVACY</h4>
                  <p className="text-gray-700">Our services are not directed to children under 13. We do not knowingly collect information from minors without parental consent.</p>
                </div>
                
                <div>
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">10. CHANGES TO THIS PRIVACY POLICY</h4>
                  <p className="text-gray-700">We may update this Privacy Policy periodically. Updates will be posted on this Website with a revised effective date.</p>
                </div>
                
                <div>
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">11. CONTACT INFORMATION</h4>
                  <p className="text-gray-700 mb-2">For privacy-related questions or requests, contact us at:</p>
                  <ul className="list-disc list-inside text-gray-700 space-y-1 ml-4">
                    <li>Email: <span style={{
                      fontFamily: 'Montserrat',
                      fontWeight: 700,
                      fontStyle: 'Bold',
                      fontSize: '16px',
                      lineHeight: '156%',
                      letterSpacing: '1.6px',
                      textDecoration: 'underline',
                      textDecorationStyle: 'solid',
                      color: '#C7A064'
                    }}>hairtodyefor10@gmail.com</span></li>
                    <li>Phone: <span style={{
                      fontFamily: 'Montserrat',
                      fontWeight: 700,
                      fontStyle: 'Bold',
                      fontSize: '16px',
                      lineHeight: '156%',
                      letterSpacing: '1.6px',
                      textDecorationStyle: 'solid',
                      color: '#C7A064'
                    }}>610-923-3530</span></li>
                    <li>Address: <span style={{
                      fontFamily: 'Montserrat',
                      fontWeight: 700,
                      fontStyle: 'Bold',
                      fontSize: '16px',
                      lineHeight: '156%',
                      letterSpacing: '1.6px',
                      textDecorationStyle: 'solid',
                      color: '#C7A064'
                    }}>200 Northampton St, Easton, PA 18042</span></li>
                  </ul>
                </div>
                
                {/* Divider */}
                <hr className="border-gray-300 my-8" />
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default LegalPrivacyPage;
